"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _Event = _interopRequireDefault(require("../../darkmatter/Event/Event"));

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var SocialMedia = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(SocialMedia, _React$PureComponent);

  var _super = _createSuper(SocialMedia);

  function SocialMedia() {
    (0, _classCallCheck2["default"])(this, SocialMedia);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SocialMedia, [{
    key: "getColor",
    value: function getColor(colors, type) {
      if (colors === 'brand' && type) return type;
      if (colors !== 'primary' && colors !== 'secondary' && colors !== 'default') return colors;
      return null;
    }
  }, {
    key: "mapValueToButton",
    value: function mapValueToButton(_ref) {
      var link = _ref.link,
          type = _ref.type,
          label = _ref.label;
      var _this$props = this.props,
          colors = _this$props.colors,
          buttonType = _this$props.buttonType,
          showLabels = _this$props.showLabels,
          inverted = _this$props.inverted,
          labelPosition = _this$props.labelPosition;
      var color = this.getColor(colors, type);

      var ButtonComponent = /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        key: label,
        primary: colors === 'primary',
        secondary: colors === 'secondary',
        inverted: inverted,
        as: "a",
        target: "_blank",
        href: link,
        circular: buttonType === 'circle',
        color: color,
        icon: type,
        label: label,
        labelPosition: labelPosition
      });

      if (!showLabels) {
        ButtonComponent = /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
          key: label,
          primary: colors === 'primary',
          secondary: colors === 'secondary',
          inverted: inverted,
          as: "a",
          target: "_blank",
          href: link,
          circular: buttonType === 'circle',
          color: color,
          icon: type
        });
      }

      if (label && label !== "" && showLabels && labelPosition === 'free') {
        ButtonComponent = /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
          key: label,
          primary: colors === 'primary',
          secondary: colors === 'secondary',
          inverted: inverted,
          as: "a",
          target: "_blank",
          href: link,
          circular: buttonType === 'circle',
          color: color
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
          name: type
        }), label);
      }

      return /*#__PURE__*/_react["default"].createElement(_Event["default"], {
        event: {
          category: 'Social Media',
          action: 'Click',
          label: link
        },
        eventType: "click"
      }, ButtonComponent);
    }
  }, {
    key: "renderButtonGroup",
    value: function renderButtonGroup() {
      var _this = this;

      var _this$props2 = this.props,
          socialMediaValues = _this$props2.socialMediaValues,
          groupButtons = _this$props2.groupButtons,
          groupVertically = _this$props2.groupVertically;

      if (groupButtons) {
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button.Group, {
          vertical: groupVertically
        }, socialMediaValues.map(function (value) {
          return _this.mapValueToButton(value);
        }));
      }

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, socialMediaValues.map(function (value) {
        return _this.mapValueToButton(value);
      }));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this$props3 = this.props,
          header = _this$props3.header,
          centerHeader = _this$props3.centerHeader;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h2",
        textAlign: centerHeader ? 'center' : 'left'
      }, header);
    }
  }, {
    key: "render",
    value: function render() {
      var header = this.props.header;
      return /*#__PURE__*/_react["default"].createElement("div", null, header && this.renderHeader(), this.renderButtonGroup());
    }
  }]);
  return SocialMedia;
}(_react["default"].PureComponent);

exports["default"] = SocialMedia;
SocialMedia.propTypes = {
  socialMediaValues: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    type: _propTypes["default"].string.isRequired,
    link: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string
  })).isRequired,
  buttonType: _propTypes["default"].oneOf(['rect', 'circle']),
  centerHeader: _propTypes["default"].bool,
  colors: _propTypes["default"].string,
  groupButtons: _propTypes["default"].bool,
  groupVertically: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  inverted: _propTypes["default"].bool,
  labelPosition: _propTypes["default"].oneOf(['left', 'right', 'free']),
  showLabels: _propTypes["default"].bool
};
SocialMedia.defaultProps = {
  buttonType: 'circle',
  centerHeader: false,
  colors: 'default',
  groupButtons: false,
  groupVertically: false,
  header: '',
  inverted: false,
  labelPosition: 'free',
  showLabels: false
};
SocialMedia.propOptions = {
  colors: ['primary', 'secondary', 'default'],
  header: ['Social Media', 'Our Social Media Addresses', '']
};
SocialMedia.dataPropsMap = {
  socialMediaValues: ['business', 'social_media']
};